import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { CookieService } from "ngx-cookie-service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private cookieService: CookieService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // ✅ Fetch token directly at the time of request
    const token: string | null = this.cookieService.get("token") || localStorage.getItem("token");

    console.log("Interceptor: Token being sent:", token); // ✅ Debugging

    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    } else {
      console.warn("🚨 No token found! Ensure user is logged in.");
    }

    return next.handle(request);
  }
}
